import request from "../../request"

export let getAnetaret = async () => {
    let strukturat = await request(
        {},
        `api/anetar/GetAllAnetaret`,
        "index"
    );
    return strukturat;
};
